import React from 'react';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';
import { BarcodeApplierIcon } from '../../../../../bombiix-icon';
import '../../../../DevlopmentOrder/ProductIdentifierTSX/product-identifier.css';

interface IdentifierActionHeaderProps {
  header: string;
  tooltipText: string;
  disabled: boolean;
  onAction: () => void;
}

interface IdentifierHeaderLabelProps {
  header: string;
}

function IdentifierActionHeader({ header, tooltipText, disabled, onAction }: IdentifierActionHeaderProps): React.ReactElement {
  return (
    <div className="retail-pull-header">
      <IdentifierHeaderLabel header={header} />
      <CustomTooltip tooltipText={tooltipText} placement="top">
        <span className="retail-pull-header__trigger">
          <button
            type="button"
            className="retail-pull-header__btn"
            aria-label={tooltipText}
            disabled={disabled}
            onClick={onAction}
          >
            <BarcodeApplierIcon size={24} aria-hidden="true" />
          </button>
        </span>
      </CustomTooltip>
    </div>
  );
}

export default IdentifierActionHeader;

export function IdentifierHeaderLabel({ header }: IdentifierHeaderLabelProps): React.ReactElement {
  return (
    <CustomTooltip tooltipText={header} placement="top">
      <span className="d-block text-truncate">{header}</span>
    </CustomTooltip>
  );
}
